"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var ImageIndicatorWrapper = _styledComponents.default.ul.withConfig({
  displayName: "ImageIndicatorWrapper",
  componentId: "sc-geknu8-0"
})(["position:absolute;top:75%;bottom:0;display:inline-flex;z-index:1;align-items:center;left:25%;"]);
var _default = ImageIndicatorWrapper;
exports.default = _default;